import { api } from "../api";

export const sendBillingPdf = async (projectId, billingKind) => {
  let url = `/billing/${projectId}`;
  return await api.post(url, {
    billingKind,
  });
};

export const resendBillingPdf = async (projectId, billingKind) => {
  let url = `/billing/resend/${projectId}`;
  return await api.post(url, {
    billingKind,
  });
};
